export default class AppError extends Error {
  constructor(data) {
    super(data.detail)
    this.statusCode = data.status
    this.appResultCode = data.appResultCode
    this.message = data.detail
    this.additionalData = data.ExceptionReturnData
  }
}
